import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const courseProgressImporterSelectors = importerSelectors(
  'courseProgress.importer',
)

export default courseProgressImporterSelectors
